<script>
import {ProductApi} from "@core/api";
import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    props: {
        multiple: {
            type: Boolean,
            default: true
        },
        selected: {
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            statements: [],
            value: this.selected.map(item => item.property)
        };
    },
    watch: {
        selected() {
            this.value = this.selected.map(item => item.property);
        }
    },
    created() {
        ProductApi.getAllGeneralProductStatements().then((res) => {
            this.statements = res.data;
        });
    }
}
</script>

<template>
    <v-select
        v-model="value"
        :options="statements"
        :multiple="multiple"
        @input="$emit('input', value)"
        label="productStatement"
    />
</template>
